const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 35,
    viewBox: "0 0 112 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M111,29.29c0,2.82-2.31,4.71-5.75,4.71H7c-3.31,0-6.01-2.36-6.01-5.27V6.27c.01-2.9,2.7-5.27,6.01-5.27h98.25c3.21,0,5.75,2.31,5.75,5.27v23.02Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,29.29c0,2.82-2.31,4.71-5.75,4.71H7c-3.31,0-6.01-2.36-6.01-5.27V6.27c.01-2.9,2.7-5.27,6.01-5.27h98.25c3.21,0,5.75,2.31,5.75,5.27v23.02Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,29.29c0,2.82-2.31,4.71-5.75,4.71H7c-3.31,0-6.01-2.36-6.01-5.27V6.27c.01-2.9,2.7-5.27,6.01-5.27h98.25c3.21,0,5.75,2.31,5.75,5.27v23.02ZM105.25,0H7C3.14,0,0,2.81,0,6.27v22.46c0,3.46,3.14,6.27,7,6.27h98.25c4.03,0,6.75-2.3,6.75-5.71V6.27c.01-3.51-2.96-6.27-6.75-6.27Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.36,18.7h1.95c.71,1.71,1.42,3.43,2.12,5.14.65-1.71,1.32-3.43,1.97-5.14h2.01c-1.57,3.63-3.14,7.26-4.73,10.89h-1.89c.58-1.23,1.14-2.46,1.73-3.69-1.05-2.4-2.11-4.79-3.16-7.19h0ZM68.76,22.4c1.12-.46,2.23-.93,3.36-1.39-.38-.62-1.13-.91-1.83-.7-.92.27-1.54,1.12-1.53,2.08h0ZM68.29,19.69c1.05-.97,2.58-1.21,3.87-.6.98.5,1.61,1.49,1.92,2.52-1.67.7-3.35,1.39-5.02,2.08.26.5.71.87,1.25,1.03.93.24,1.91-.16,2.41-.98.44.29.88.58,1.32.88-.45.67-1.1,1.18-1.85,1.46-1.33.49-2.82.2-3.86-.77-1.55-1.44-1.53-4.17-.03-5.64h0v.02ZM59.5,20.29c-1.16.17-1.92,1.39-1.77,2.51.07,1.19,1.25,2.22,2.44,1.95,1.15-.23,1.78-1.53,1.58-2.62-.11-1.08-1.13-2.05-2.24-1.85h0ZM57.61,19.42c1.16-.89,2.98-.93,4.04.15v-.6h1.61v6.93c0,1.13-.37,2.35-1.29,3.07-1.4,1.06-3.59.96-4.82-.31-.35-.36-.63-.77-.84-1.22.49-.21.98-.42,1.47-.62.18.38.45.71.78.97.84.64,2.23.45,2.78-.48.35-.55.32-1.23.32-1.86-.62.64-1.5.94-2.38.82-1.41-.18-2.6-1.16-3.05-2.51-.54-1.6.03-3.37,1.4-4.36h-.02v.02ZM50.82,20.35c-1.17.33-1.78,1.71-1.44,2.84.27,1.07,1.43,1.88,2.52,1.53,1.17-.27,1.83-1.63,1.53-2.75-.21-1.15-1.48-1.99-2.61-1.61h0ZM50.57,18.82c1.28-.27,2.62.11,3.55,1.03,1.43,1.42,1.41,4.02-.07,5.39-1.5,1.52-4.26,1.38-5.6-.27-1.21-1.43-1.14-3.79.21-5.12.52-.53,1.18-.88,1.9-1.03h0ZM42.57,20.36c-.96.38-1.54,1.36-1.43,2.38.11,1.03.88,1.85,1.9,2.03,1.3.14,2.43-1.15,2.27-2.41,0-1.34-1.44-2.49-2.73-1.99h-.01ZM42.42,18.81c1.39-.29,2.83.21,3.75,1.29,1.27,1.53,1.07,4.06-.49,5.32-1.35,1.15-3.31,1.22-4.74.16s-1.93-2.96-1.23-4.59c.48-1.14,1.5-1.96,2.71-2.19h0ZM91.99,22.91c-.55.38-.56,1.31.08,1.61,1.22.68,2.78-.31,2.95-1.61-.93-.48-2.14-.59-3.05.02v-.02h.02ZM89.98,20.05c.92-1.88,3.51-2.26,5.23-1.33.95.52,1.55,1.51,1.57,2.6.02,1.59,0,3.19,0,4.78h-1.76v-.93c-1.14,1.8-4.25,1.43-5.06-.5-.47-1.14-.03-2.45,1.04-3.06,1.24-.71,2.75-.77,4.05-.16-.05-1.72-2.72-2.15-3.48-.7-.53-.24-1.09-.43-1.61-.7h.02ZM86.77,26.1v-10.96h1.79v10.96h-1.79ZM79.73,16.79v3.49c.78,0,1.56.03,2.33-.01.85-.09,1.52-.76,1.61-1.61.03-.94-.67-1.74-1.61-1.83-.78-.03-1.57,0-2.35,0l.02-.03h0ZM78.02,15.11h3.8c.91,0,1.79.32,2.49.9.83.72,1.25,1.82,1.13,2.91-.13,1.1-.79,2.06-1.77,2.57-1.2.67-2.62.41-3.93.46v4.11h-1.72v-10.96h0ZM64.56,15.11h1.68v11.03h-1.68v-11.03ZM27.89,18.02c.88-1.93,2.71-3.25,4.82-3.47,1.68-.18,3.35.4,4.55,1.59-.38.38-.77.76-1.13,1.16-.84-.8-1.97-1.21-3.12-1.14-1.18.08-2.27.66-2.99,1.61-.7.93-1,2.1-.83,3.26.2,1.42,1.11,2.64,2.41,3.24,1.54.7,3.55.37,4.67-.93.41-.53.68-1.16.76-1.83-1.26-.04-2.52,0-3.78-.02v-1.65h5.36c.25,1.41,0,2.87-.74,4.1-.84,1.27-2.2,2.1-3.71,2.27-1.23.17-2.48-.04-3.58-.61-2.76-1.41-3.94-4.73-2.68-7.57",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.11,21.1l-3.56,1.95-2.14-2.15.2-.2,2.02-2.02,3.48,1.91c.17.09.25.2.25.27s-.08.15-.25.24h0ZM9.07,28.24l6.77-6.78.17.17,1.82,1.82-8.75,4.79h-.01ZM7.2,28.98c-.13-.07-.22-.2-.23-.35v-15.57c0-.12.07-.24.16-.32l8.13,8.15-8.07,8.07v.02ZM16.47,17.5l1.41.77-2.05,2.06-6.99-7,7.63,4.18h0ZM22.48,19.88l-3.75-2.06-10.54-5.77c-.26-.15-.55-.23-.85-.22-.08,0-.15,0-.22.02-.02,0-.02.03-.03.03-.53.14-.9.62-.91,1.17v15.57c0,.6.45,1.11,1.05,1.2.02,0,.04.02.07.02h.05c.31,0,.62-.08.9-.24l10.45-5.72,3.82-2.09c.4-.15.67-.53.67-.96s-.27-.81-.67-.96h-.04Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.07,5c-.78-.02-1.53.26-2.11.77h0c-.89.76-1.13,2.05-.83,3.14.19.6.57,1.13,1.08,1.5.52.37,1.14.57,1.78.56.54.03,1.07-.1,1.54-.37.46-.27.84-.67,1.08-1.15.22-.54.29-1.13.22-1.71h-2.83v.76h2.1c-.12,1.45-1.97,2.18-3.16,1.45-1.31-.68-1.53-2.69-.41-3.64.42-.39.99-.59,1.56-.58.58.02,1.12.26,1.52.67l.54-.53c-.55-.54-1.3-.85-2.07-.87h-.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.08,5.13h-3.41v5.73h3.41v-.75h-2.64v-1.75h2.36v-.72h-2.36v-1.78h2.64v-.73Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.64,5.14h-3.98,0v.72h1.6v5h.76v-5h1.6v-.72h.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.92,5.15h-.8v5.71h.8v-5.71Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.54,5.13h-3.98.02v.73h1.6v5h.76v-5h1.6s0-.73,0-.73Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.48,5.16h-.93v5.7h.76c-.03-1.54.07-3.09-.06-4.63,1.01,1.52,1.95,3.09,2.94,4.63h.8v-5.71h-.76v4.37c-.92-1.45-1.84-2.91-2.76-4.36h.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.75,5.79c-.79-.79-2.06-.96-3.1-.61h0c-1.84.64-2.49,3.15-1.31,4.65.96,1.36,3.14,1.56,4.36.43,1.31-1.1,1.32-3.34.05-4.47ZM55.68,10.23c-1.23,0-2.23-1-2.23-2.23s1-2.23,2.23-2.23,2.23,1,2.23,2.23-1,2.23-2.23,2.23Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6b012dea4b66df6c868f188cec0daa10.svg";
export { ForwardRef as ReactComponent };